<template>
    <li class="event d-flex px-3 py-2" :class="{ current: selected }" v-on:click="onClick">
        <div class="date d-flex flex-column mr-2 flex-shrink-0">
            <span class="day">{{ day }}</span>
            <span class="month">{{ month }}</span>
        </div>
        <div class="info flex-fill d-flex align-items-center">
            <h4 class="text-secondary text-uppercase text-truncate">{{ event.title }}</h4>
        </div>
    </li>
</template>

<script>
import { DateTime } from 'luxon';

export default {
    name: 'eventlistitem',
    props: ['event'],
    mounted() {
        this.$root.$on('changelocale', () => {
            // forces recomputation
            this.event.__ob__.dep.notify()
        });
    },
    beforeDestroy() {
        this.$root.$off('changelocale');
    },
    computed: {
        selected: function () {
            return this.$route.params.path === this.event._id;
        },
        day: function () {
            if (!this.event.date) return '00';
            return DateTime.fromISO(this.event.date).toFormat('dd');
        },
        month: function () {
            if (!this.event.date) return '';
            return DateTime.fromISO(this.event.date).toFormat('MMM');
        }
    },
    methods: {
        onClick: function () {
            this.$router.push({ path: 'events', query: { id: this.event._id }});
        }
    },
};
</script>

<style lang="scss">
.event {

    cursor: pointer;

    .info {
        overflow: hidden;

        h4 {
            font-size: 1.3em;
            font-weight: 300;
        }
    }

    .date {
        width: 40px;

        .day {
            font-size: 25px;
            line-height: 24px;
            font-weight: 500;
            color: #888;
        }

        .month {
            color: #888;
        }
    }

    border: 1px solid #888;
    background-color: #fff;

    &.current {
        background-color: #eee;
    }

    &:first-child {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    &:last-child {
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
</style>